import { yarnType } from '@/constants/yarns'
import type { Supplier } from '@/types/supplier-types'
import type { Product } from '@/types/product-types'

export const products = [
    {
        id: 1,
        productReference: 'TEC738 RED',
        yarnType: 'CottonYarn',
        status: 'Finished',
        weightPerSquareMeter: 140,
        guage: 18,
        gating: 'int',
        takeDown: 'no',
        rollLength: 44,
        machineSpeed: 300
    },
    {
        id: 2,
        productReference: 'TEC738 BLUE',
        yarnType: 'PloyesterYarn',
        status: 'Finished',
        weightPerSquareMeter: 140,
        guage: 18,
        gating: 'int',
        takeDown: 'no',
        rollLength: 44,
        machineSpeed: 300
    },
    {
        id: 3,
        productReference: 'TEC738 GREEN',
        yarnType: 'WoolYarn',
        status: 'Finished',
        weightPerSquareMeter: 140,
        guage: 18,
        gating: 'int',
        takeDown: 'no',
        rollLength: 44,
        machineSpeed: 300
    },
    {
        id: 4,
        productReference: 'TEC738 YELLOW',
        yarnType: 'SilkYarn',
        status: 'Finished',
        weightPerSquareMeter: 140,
        guage: 18,
        gating: 'int',
        takeDown: 'no',
        rollLength: 44,
        machineSpeed: 300
    }
]

export const getUnfinishedProduct = (id?: string, products: Product[] | undefined) => {
    const product = products?.find((product: Product) => product.id === id)
    return product?.unfinishedReference
}

export const getFinishedProduct = (id?: string, products: Product[] | undefined) => {
    const product = products?.find((product: Product) => product.id === id)
    return product?.finishedReference
}